export const toggleBodyScrollable = (scrollable: boolean) => {
    const doc = window.document;
    if (!scrollable) {
        doc.body.setAttribute(
            'style',
            `${doc.body.getAttribute('style') || ''}max-height: 100vh; overflow-y: hidden;`
        );
    } else {
        // fixme What if the body has its own inline styles?
        doc.body.setAttribute('style', '');
    }
};

// https://stackoverflow.com/questions/1145850/how-to-get-height-of-entire-document-with-javascript
export const getPageHeight = () => {
    const { body } = document;
    const html = document.documentElement;

    return Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
    );
};

export const scrollToElement = (targetId: string, offset?: number) => {
    const firstElement = document.getElementById(targetId);

    if (!firstElement) return;

    const offsetPosition =
        firstElement.getBoundingClientRect().top + window.pageYOffset - (offset || 0);
    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
    });
};
